import useSound from 'use-sound'

type Return = {
  play: () => void
}

export function useSoundAdapter(pathFile?: string): Return {
  const [play] = useSound(pathFile ?? '')
  return { play }
}
